import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=ba20b714&scoped=true"
import script from "./blog.vue?vue&type=script&lang=js"
export * from "./blog.vue?vue&type=script&lang=js"
import style0 from "./blog.vue?vue&type=style&index=0&id=ba20b714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba20b714",
  null
  
)

export default component.exports